/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Window_ClosedInputs */

const fr_household_window_closed = /** @type {(inputs: Household_Window_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscriptions fermées`)
};

/**

* @param {Household_Window_ClosedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_window_closed = /** @type {((inputs?: Household_Window_ClosedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Window_ClosedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_window_closed(inputs)
});